import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { LangProvider } from "./contexts/LangContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ClientsPage from "./pages/ClientsPage";
import ClientProfilePage from "./pages/ClientProfilePage";
import SettingsPage from "./pages/SettingsPage";
import DevicesPage from "./pages/DevicesPage";
import VehiclesPage from "./pages/VehiclesPage";
import SubscriptionsPage from "./pages/SubscriptionsPage";
import PaymentsPage from "./pages/PaymentsPage";
import AlertsPage from "./pages/AlertsPage";
import UsersPage from "./pages/UsersPage";

function App() {
    return (
        <div className="App">
            <LangProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/login" element={<LoginPage />} />
                            <Route path="/sa/login" element={<LoginPage />} />
                            <Route
                                path="/"
                                element={
                                    <ProtectedRoute>
                                        <Layout />
                                    </ProtectedRoute>
                                }
                            >
                                <Route index element={<Navigate to="/dashboard" replace />} />
                                <Route path="dashboard" element={<DashboardPage />} />
                                <Route path="clients" element={<ClientsPage />} />
                                <Route path="clients/:id" element={<ClientProfilePage />} />
                                <Route path="devices" element={<DevicesPage />} />
                                <Route path="vehicles" element={<VehiclesPage />} />
                                <Route path="subscriptions" element={<SubscriptionsPage />} />
                                <Route path="payments" element={<PaymentsPage />} />
                                <Route path="alerts" element={<AlertsPage />} />
                                <Route
                                    path="users"
                                    element={
                                        <ProtectedRoute roles={["admin"]}>
                                            <UsersPage />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="settings"
                                    element={
                                        <ProtectedRoute roles={["admin"]}>
                                            <SettingsPage />
                                        </ProtectedRoute>
                                    }
                                />
                            </Route>
                            <Route path="*" element={<Navigate to="/dashboard" replace />} />
                        </Routes>
                    </BrowserRouter>
                </AuthProvider>
            </LangProvider>
        </div>
    );
}

export default App;
